/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Link } from '@ta-interaktiv/contentbricks'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

// GET PARAMS FROM URL
const params = new URL(window.location).searchParams

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      teaserImage: params.get('image')
        ? params.get('image')
        : 'https://interaktiv.tagesanzeiger.ch/inline-teaser/missing.png',
      articleID: params.get('article'),
      targetURL: params.get('url'),
      tennantDomain: 'tagesanzeiger.ch'
    }
  }

  componentDidMount() {
    console.log('articleID: ', this.state.articleID)
    console.log('targetURL: ', this.state.targetURL)

    let publicationDomain = parseHostname().publicationDomain
    // console.log('publicationDomain: ', publicationDomain)
    this.setState({ tennantDomain: publicationDomain })

    if (document.referrer) {
      // console.log('document referrer: ', document.referrer)
      let url = document.referrer
      let ref = url.match(/:\/\/(.[^/]+)/)[1]
      // console.log('ref: ', ref)

      if (ref.includes('www.')) {
        let rawRefDomain = ref.split('www.')
        let refDomain = rawRefDomain[1]
        // console.log('refDomain: ', refDomain)
        this.setState({ tennantDomain: refDomain })
      } else {
        this.setState({ tennantDomain: ref })
      }
    }
  }

  render() {
    return (
      <div className='index'>
        {this.state.articleID !== null && (
          <Link
            hideIcon
            href={
              'https://www.' +
              this.state.tennantDomain +
              '/' +
              this.state.articleID
            }
          >
            <img className='ui fluid image' src={this.state.teaserImage} />
          </Link>
        )}
        {this.state.targetURL !== null && (
          <Link hideIcon href={this.state.targetURL}>
            <img className='ui fluid image' src={this.state.teaserImage} />
          </Link>
        )}
      </div>
    )
  }
}
